import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';

interface FileUploadSectionProps {
	fileName: string;
	onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	fileInputRef: React.RefObject<HTMLInputElement>;
	t: (key: string) => string;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
	fileName,
	onFileChange,
	fileInputRef,
	t
}) => {
	return (
		<div className="mb-4">
			<label className="block mb-2">
				<Typography size="md" weight="medium">
					{t('UploadFile')}
				</Typography>
			</label>
			<div className="flex items-center gap-3">
				<input
					ref={fileInputRef}
					type="file"
					accept=".json,.csv"
					onChange={onFileChange}
					className="hidden"
					id="file-upload"
				/>
				<label
					htmlFor="file-upload"
					className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#16825D] hover:bg-[#1a9e6f] text-white font-medium rounded cursor-pointer transition-colors duration-200 shadow-sm"
					style={{
						fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
					}}
				>
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
					</svg>
					{t('ChooseFile')}
				</label>
				{fileName && (
					<div className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded border border-gray-200">
						<svg
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M9 1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V5L9 1z"
								stroke="#6B7280"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M9 1v4h4"
								stroke="#6B7280"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
						<Typography size="sm" color="secondary">
							{fileName}
						</Typography>
					</div>
				)}
			</div>
			<div className="mt-2">
				<Typography size="sm" color="secondary">
					{t('AcceptedFormats')}: JSON, CSV
				</Typography>
			</div>
		</div>
	);
};

export default FileUploadSection;
